class ProductSiblings extends HTMLElement {
  static observedAttributes = ["title", "product-id", "hide-current"];

  constructor() {
    super();
    console.log('Product Siblings: Started');
  }

  attributeChangedCallback(name, oldValue, newValue) {
    // console.log(
    //   `Attribute ${name} has changed from ${oldValue} to ${newValue}.`,
    // );
    switch (name) {
      case "title" || "hide-current":
        if (newValue) {
          this.init(newValue);
        }
        break;

      case "product-id":
        if (/^\d+$/.test(newValue)) {
          this.currentId = +newValue
        }
        break;
    }
  }

  async init(newValue) {
    this.settings = {
      hideCurrent: this.getAttribute('hide-current') === "true" ? true : false
    }

    const query = `{
      products(first: 20, query:"title:${newValue}*") {
        edges {
          node {
            id
            title
            handle
            featuredImage {
              src
            }
            tags
          }
        }
      }
    }`;

    try {
      const req = await fetch(`https://thbrown.myshopify.com/api/2025-04/graphql`, {
        method: "POST",
        headers: {
          "Content-Type": "application/graphql",
          "X-Shopify-Storefront-Access-Token": "88b96f3f4ce1a51d9d5d66950b323f15"
        },
        body: query
      });
      const res = await req.json();

      // console.log({ res, req })
      if (req.ok) {
        if (!res.data) {
          console.log('Product Siblings: Missing data. Please try again');
          return;
        }
        const { products: { edges: products } } = res.data;
        const filtered = products.filter(p => p.node.title.startsWith(newValue));

        if (filtered.length === 1 && this.settings.hideCurrent) {
          this.classList.add('hidden');
          return;
        }

        this.renderProducts(filtered);
      }
    } catch (error) {
      console.log('Product siblings: Error in fetch. Please try again', { error });
    }
  }

  updateSwatchName(item = {}) {
    const { title } = item.node; 
    const target = this.querySelector('.swatch-name');
    if (!target) return;
    target.innerHTML = title.split(' - ').at(-1);
  }

  renderProducts(products = null) {
    if (!products) {
      console.log('Product siblings: No products found')
      return;
    }

    const productItems = products.map(item => {
      const { featuredImage, handle, title, id } = item.node;
      const pid = id.split('/').at(-1);
      const isCurrentProduct = +pid === this.currentId;
      const name = title.split(' - ').at(-1);
      return `
        <div class="variant-option__button-label variant-option__button-label--has-swatch${isCurrentProduct ? ' active' : ''}">
          <a href="/products/${handle}" title="${name}">
            <img class="swatch swatch--unscaled" src="${featuredImage.src}&width=40" alt="${name}" loading="lazy" width="40" />
          </a>
        </div>
      `;
    }).join('');

    const content = document.createElement('div');
    content.classList.add('variant-picker', 'spacing-style', 'variant-picker--left');
    content.innerHTML = `
      <div class="variant-option variant-option--buttons variant-option--swatches">${productItems}</div>
    `;

    // Update swatch name beside heading
    const currentProduct = products.find(({ node: { id } }) => +id.split('/').at(-1) === this.currentId);
    if (currentProduct) this.updateSwatchName(currentProduct);
    
    this.appendChild(content);
    this.classList.remove('hidden');
  }
}
if (!customElements.get('product-siblings')){
  customElements.define('product-siblings', ProductSiblings);
}